/**
 * mp-search.js v5 (23-09-2026) — la ricerca di Martin Parfums.
 *
 * Appena si apre, senza scrivere niente:
 *   1. RICERCHE RECENTI  — le ultime 6 parole cercate da questo browser (con «Cancella»)
 *   2. CERCA SPESSO      — le parole più utili del catalogo (marchi ispirati e famiglie)
 *   3. VISTI DI RECENTE  — gli ultimi profumi aperti da questo browser (con «Svuota»)
 *   4. I PIÙ VENDUTI     — dalla collezione della home (mp-search-popular.liquid), la base per chi arriva la prima volta
 * Si cerca per nome, «ispirato a», parole chiave E famiglia olfattiva (vaniglia, legnoso, agrumato…).
 * Invio porta alla pagina con tutti i risultati. Tutto resta su questo dispositivo: niente account, niente server.
 */
(function () {
  'use strict';

  /* ── Config ──────────────────────────────────────────────────────── */
  /* ripiego se l'indice non è ancora pronto: le scorciatoie vere nascono dal catalogo (vedi scorciatoie()) */
  var POPULAR_FALLBACK = ['Creed', 'Tom Ford', 'Agrumato', 'Legnoso', 'Speziato', 'Fresco'];
  var RESULT_LIMIT = 8;
  var MIN_QUERY    = 2;
  var SEEN_KEY     = 'mp-srch-seen';    // profumi aperti di recente (handle)
  var RECENT_KEY   = 'mp-srch-recent';  // parole cercate di recente
  var SEEN_MAX     = 8;
  var RECENT_MAX   = 6;

  /* ── Memoria di questo browser ────────────────────────────────────── */
  function readList(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function writeList(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }
  function pushList(key, value, max) {
    if (!value) return;
    var list = readList(key).filter(function (v) { return normalize(v) !== normalize(value); });
    list.unshift(value);
    writeList(key, list.slice(0, max));
  }
  /* la scheda prodotto aperta adesso finisce fra i «visti di recente» */
  function trackProductView() {
    var m = /^\/products\/([^/?#]+)/.exec(location.pathname);
    if (m) pushList(SEEN_KEY, decodeURIComponent(m[1]), SEEN_MAX);
  }
  function byHandle(handle) {
    var idx = getIndex();
    for (var i = 0; i < idx.length; i++) {
      if (idx[i].handle === handle) return idx[i];
    }
    return null;
  }

  /* ── Index access ─────────────────────────────────────────────────── */
  function getIndex() {
    return Array.isArray(window.MP_SEARCH_INDEX) ? window.MP_SEARCH_INDEX : [];
  }

  function normalize(s) {
    return (s || '').toString().toLowerCase()
      .replace(/[àáâã]/g, 'a')
      .replace(/[èéêë]/g, 'e')
      .replace(/[ìíîï]/g, 'i')
      .replace(/[òóôõ]/g, 'o')
      .replace(/[ùúûü]/g, 'u')
      .trim();
  }

  /* ── Ricerca: nome, «ispirato a», parole chiave, famiglia olfattiva, genere ──
     Prima i nomi che iniziano con quello che scrivi, poi il resto. */
  function localSearch(q) {
    var nq = normalize(q);
    if (nq.length < MIN_QUERY) return [];
    var idx = getIndex(), primi = [], poi = [];
    for (var i = 0; i < idx.length; i++) {
      var p = idx[i];
      if (p.available === false) continue;
      var titolo = normalize(p.title);
      var campi = [titolo, normalize(p.inspired_name), normalize(p.keywords), normalize(p.olf_tags), normalize(p.gender)].join(' | ');
      if (campi.indexOf(nq) === -1) continue;
      if (titolo.indexOf(nq) === 0) primi.push(p); else poi.push(p);
    }
    return primi.concat(poi).slice(0, RESULT_LIMIT);
  }

  /* ── Build card HTML from search index entry ─────────────────────── */
  function buildCard(p) {
    /* Immagine — 400×400 square crop via Shopify CDN per card uniformi */
    var imgHtml = '';
    if (p.image) {
      var src = p.image.replace(/^\/\//, 'https://');
      /* 1) rimuove eventuale size suffix già presente (es. _800x, _1024x1024_crop_center) */
      src = src.replace(/_\d+x\d*(?:_crop_\w+)?(\.(?:jpg|jpeg|png|gif|webp))/i, '$1');
      /* 2) aggiunge _400x400_crop_center per forzare quadrato uniforme */
      src = src.replace(/(\.(?:jpg|jpeg|png|gif|webp))/i, '_400x400_crop_center$1');
      imgHtml = '<img src="' + src + '" alt="' + esc(p.title) + '" loading="lazy">';
    }

    /* Badge genere UOMO / DONNA / UNISEX — quadrato scuro top-right */
    var badgeHtml = p.gender
      ? '<div class="mp-product-badges"><span class="mp-badge mp-badge--gender">' + esc(p.gender) + '</span></div>'
      : '';

    /* Prezzo */
    var price = p.price_cents
      ? '€' + (p.price_cents / 100).toFixed(2).replace('.', ',')
      : '';

    /* Olfactory tags */
    var olfHtml = '';
    if (p.olf_tags) {
      var olfs = p.olf_tags.split(',')
        .map(function (t) { return t.trim(); })
        .filter(Boolean)
        .slice(0, 2);
      if (olfs.length) {
        var pills = olfs.map(function (t) {
          var key = normalize(t).replace(/\s+/g, '-');
          return '<span class="mp-otags__tag mp-otags__tag--' + key + '">' + esc(t) + '</span>';
        }).join('');
        olfHtml = '<div class="mp-otags">' + pills + '</div>';
      }
    }

    /* "Ispirato a NAME" — testo diretto, stesso stile homepage */
    var inspHtml = p.inspired_name
      ? '<p class="mp-srch-card__inspired">Ispirato a <strong>' + esc(p.inspired_name) + '</strong></p>'
      : '';

    return (
      '<a href="' + p.url + '" class="mp-srch-card">' +
        '<div class="mp-srch-card__img">' + imgHtml + badgeHtml + '</div>' +
        '<div class="mp-srch-card__info">' +
          '<p class="mp-srch-card__title">' + esc(p.title) + '</p>' +
          (price ? '<p class="mp-srch-card__price">' + price + '</p>' : '') +
          olfHtml +
          inspHtml +
        '</div>' +
      '</a>'
    );
  }

  function esc(s) {
    return (s || '').toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Build overlay DOM ───────────────────────────────────────────── */
  /* Scorciatoie di ricerca prese dai profumi veri: prima i marchi a cui si ispirano, poi le famiglie olfattive
     più presenti. Così non si propone mai una parola che non trova niente (prima «Vaniglia» non dava risultati). */
  function scorciatoie() {
    var idx = getIndex(), marchi = {}, famiglie = {};
    idx.forEach(function (p) {
      if (p.available === false) return;
      (p.olf_tags || '').split(',').forEach(function (t) {
        t = t.trim(); if (t) famiglie[t] = (famiglie[t] || 0) + 1;
      });
      var parti = (p.inspired_name || '').split(' - ');
      if (parti.length > 1) {
        var m = parti[parti.length - 1].trim();
        if (m) marchi[m] = (marchi[m] || 0) + 1;
      }
    });
    var top = function (o, n) {
      return Object.keys(o).sort(function (a, b) { return o[b] - o[a] || a.localeCompare(b); }).slice(0, n);
    };
    var list = top(marchi, 3).concat(top(famiglie, 5));
    return list.length ? list : POPULAR_FALLBACK;
  }

  function buildOverlay() {
    var pillsHtml = scorciatoie().map(function (s) {
      return '<button class="mp-srch__pill" data-q="' + esc(s) + '">' + esc(s) + '</button>';
    }).join('');

    var div = document.createElement('div');
    div.id  = 'mp-srch';
    div.className = 'mp-srch';
    div.setAttribute('role', 'dialog');
    div.setAttribute('aria-modal', 'true');
    div.setAttribute('aria-label', 'Cerca fragranze');

    div.innerHTML = [
      '<div class="mp-srch__backdrop" id="mp-srch-bd"></div>',
      '<div class="mp-srch__panel">',

        /* ── Topbar ── */
        '<div class="mp-srch__topbar">',
          '<div class="mp-srch__input-wrap">',
            '<svg class="mp-srch__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">',
              '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>',
            '</svg>',
            '<input id="mp-srch-input" class="mp-srch__input" type="search"',
              ' autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"',
              ' placeholder="Cerca la tua fragranza"',
              ' aria-label="Cerca fragranze">',
            '<button id="mp-srch-clear" class="mp-srch__clear mp-hidden" aria-label="Cancella">&#x2715;</button>',
          '</div>',
          '<button id="mp-srch-close" class="mp-srch__close" aria-label="Chiudi ricerca">',
            '<span>CHIUDI</span>',
            '<svg class="mp-srch__close-x" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">',
              '<path d="M18 6 6 18M6 6l12 12"/>',
            '</svg>',
          '</button>',
        '</div>',

        /* ── Content ── */
        '<div class="mp-srch__content">',

          /* STATE: vuoto — ricerche recenti · cerca spesso · visti di recente · i più venduti */
          '<div id="mp-srch-empty" class="mp-srch__state mp-active">',
            '<div class="mp-srch__block" id="mp-srch-recent-b" hidden>',
              '<div class="mp-srch__section-hd">',
                '<p class="mp-srch__label">Ricerche recenti</p>',
                '<button type="button" class="mp-srch__viewall" id="mp-srch-recent-clear">Cancella</button>',
              '</div>',
              '<div class="mp-srch__pills" id="mp-srch-recent"></div>',
            '</div>',
            '<div class="mp-srch__block">',
              '<p class="mp-srch__label">Cerca spesso</p>',
              '<div class="mp-srch__pills">', pillsHtml, '</div>',
            '</div>',
            '<div class="mp-srch__block" id="mp-srch-seen-b" hidden>',
              '<div class="mp-srch__section-hd">',
                '<p class="mp-srch__label">Visti di recente</p>',
                '<button type="button" class="mp-srch__viewall" id="mp-srch-seen-clear">Svuota</button>',
              '</div>',
              '<div class="mp-srch__grid" id="mp-srch-seen"></div>',
            '</div>',
            '<div class="mp-srch__block">',
              '<div class="mp-srch__section-hd">',
                '<p class="mp-srch__label">I più venduti</p>',
                '<a href="/collections/all" class="mp-srch__viewall">Tutti i profumi &#x2192;</a>',
              '</div>',
              '<div class="mp-srch__grid" id="mp-srch-pop">',
                '<div class="mp-srch__spin"></div>',
              '</div>',
            '</div>',
          '</div>',

          /* STATE: results */
          '<div id="mp-srch-results" class="mp-srch__state">',
            '<div class="mp-srch__results-row">',
              '<span class="mp-srch__count" id="mp-srch-count"></span>',
              '<a class="mp-srch__all" id="mp-srch-all" href="/search">Tutti i risultati &#x2192;</a>',
            '</div>',
            '<div class="mp-srch__grid" id="mp-srch-rgrid"></div>',
          '</div>',

          /* STATE: nessun risultato — si riparte dalle parole che funzionano */
          '<div id="mp-srch-nores" class="mp-srch__state">',
            '<p class="mp-srch__none">Nessun profumo per &ldquo;<span id="mp-srch-term"></span>&rdquo;</p>',
            '<p class="mp-srch__label">Prova con</p>',
            '<div class="mp-srch__pills">', pillsHtml, '</div>',
          '</div>',

        '</div>',  /* /content */
      '</div>'   /* /panel */
    ].join('');

    document.body.appendChild(div);
    return div;
  }

  /* ── State management ────────────────────────────────────────────── */
  var STATES = ['empty', 'results', 'nores'];
  function setState(name) {
    STATES.forEach(function (s) {
      var el = document.getElementById('mp-srch-' + s);
      if (el) el.classList.toggle('mp-active', s === name);
    });
  }

  /* ── Visti di recente e ricerche recenti ──────────────────────────── */
  function renderSeen() {
    var box = document.getElementById('mp-srch-seen-b');
    var grid = document.getElementById('mp-srch-seen');
    if (!box || !grid) return 0;
    var qui = (/^\/products\/([^/?#]+)/.exec(location.pathname) || [])[1];
    var cards = readList(SEEN_KEY)
      .filter(function (h) { return h !== qui; })   // il profumo che stai guardando non si ripropone
      .map(byHandle)
      .filter(function (p) { return p && p.available !== false; })
      .slice(0, 4);
    box.hidden = cards.length === 0;
    grid.innerHTML = cards.map(function (p) { return buildCard(p); }).join('');
    return cards.length;
  }
  function renderRecent() {
    var box = document.getElementById('mp-srch-recent-b');
    var wrap = document.getElementById('mp-srch-recent');
    if (!box || !wrap) return;
    var list = readList(RECENT_KEY).slice(0, RECENT_MAX);
    box.hidden = list.length === 0;
    wrap.innerHTML = list.map(function (t) {
      return '<button type="button" class="mp-srch__pill" data-q="' + esc(t) + '">' + esc(t) + '</button>';
    }).join('');
  }

  /* ── Carica prodotti popolari ─────────────────────────────────────
   *  Prima usa il <template> server-side di mp-search-popular.liquid,
   *  fallback: prime voci dell'indice                                  */
  function loadPopular(grid) {
    /* Prova il template server-side */
    var tpl = document.getElementById('mp-srch-popular-tpl');
    if (tpl && tpl.content && tpl.content.childElementCount > 0) {
      var clone = document.importNode(tpl.content, true);
      grid.innerHTML = '';
      grid.appendChild(clone);
      return;
    }
    /* Fallback: prime N voci dell'indice (con bestseller=true per tutti) */
    var idx  = getIndex();
    var pops = [];
    for (var i = 0; i < idx.length && pops.length < RESULT_LIMIT; i++) {
      if (idx[i].available !== false) pops.push(idx[i]);
    }
    if (pops.length) {
      grid.innerHTML = pops.map(function (p) { return buildCard(p); }).join('');
    } else {
      grid.innerHTML = '<p class="mp-srch__none" style="text-align:left;padding:0">Nessun prodotto trovato.</p>';
    }
  }

  /* ── Open / close ────────────────────────────────────────────────── */
  var overlay, inputEl, clearBtn, popReady;

  function openSearch() {
    if (overlay.classList.contains('is-open')) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setState('empty');

    if (!popReady) {
      popReady = true;
      var grid = document.getElementById('mp-srch-pop');
      if (grid) loadPopular(grid);
    }
    renderRecent();
    /* con i «visti di recente» in cima, dei più venduti bastano quattro: la pagina resta corta */
    var quantiVisti = renderSeen();
    var pop = document.getElementById('mp-srch-pop');
    if (pop) pop.classList.toggle('is-short', quantiVisti > 0);

    setTimeout(function () {
      if (inputEl) inputEl.focus();
    }, 60);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (inputEl) inputEl.value = '';
    if (clearBtn) clearBtn.classList.add('mp-hidden');
    setState('empty');
    if (debTimer) clearTimeout(debTimer);
  }

  /* ── Intercept Broadcast search opener ───────────────────────────── */
  function setupInterception() {
    window.addEventListener('click', function (e) {
      var el = e.target;
      var isSummary = false;
      while (el && el !== document.documentElement) {
        if (el.tagName === 'SUMMARY') { isSummary = true; }
        if (el.tagName === 'HEADER-SEARCH-POPDOWN' && isSummary) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openSearch();
          return;
        }
        el = el.parentElement;
      }
    }, true);

    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var target = muts[i].target;
        if (
          target.tagName === 'DETAILS' &&
          target.hasAttribute('open') &&
          target.closest && target.closest('header-search-popdown')
        ) {
          target.removeAttribute('open');
          openSearch();
        }
      }
    });
    mo.observe(document.documentElement, {
      attributes: true,
      subtree: true,
      attributeFilter: ['open']
    });
  }

  /* ── Real-time search ─────────────────────────────────────────────── */
  var debTimer = null;

  function doSearch(q) {
    clearTimeout(debTimer);
    debTimer = setTimeout(function () {
      var trimmed = (q || '').trim();
      if (trimmed.length < MIN_QUERY) {
        setState('empty');
        return;
      }

      var products = localSearch(trimmed);

      var allLink = document.getElementById('mp-srch-all');
      if (allLink) allLink.href = '/search?type=product&q=' + encodeURIComponent(trimmed);

      var termEl = document.getElementById('mp-srch-term');
      if (termEl) termEl.textContent = trimmed;

      if (products.length === 0) {
        setState('nores');
      } else {
        var grid  = document.getElementById('mp-srch-rgrid');
        var count = document.getElementById('mp-srch-count');
        if (grid)  grid.innerHTML = products.map(function (p) { return buildCard(p); }).join('');
        if (count) count.textContent = products.length + ' risultat' + (products.length === 1 ? 'o' : 'i');
        setState('results');
      }
    }, 150);
  }

  /* ── Init ────────────────────────────────────────────────────────── */
  function init() {
    overlay  = buildOverlay();
    inputEl  = document.getElementById('mp-srch-input');
    clearBtn = document.getElementById('mp-srch-clear');
    popReady = false;

    trackProductView();
    setupInterception();

    document.getElementById('mp-srch-bd').addEventListener('click', closeSearch);
    document.getElementById('mp-srch-close').addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    });

    inputEl.addEventListener('input', function () {
      var q = inputEl.value;
      clearBtn.classList.toggle('mp-hidden', !q.trim());
      doSearch(q);
    });

    /* Invio: si va alla pagina con tutti i risultati, e la parola resta fra le ricerche recenti */
    inputEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var q = inputEl.value.trim();
      if (q.length < MIN_QUERY) return;
      e.preventDefault();
      pushList(RECENT_KEY, q, RECENT_MAX);
      location.href = '/search?type=product&q=' + encodeURIComponent(q);
    });

    overlay.addEventListener('click', function (e) {
      if (e.target.closest('#mp-srch-recent-clear')) { writeList(RECENT_KEY, []); renderRecent(); inputEl.focus(); }
      if (e.target.closest('#mp-srch-seen-clear')) {
        writeList(SEEN_KEY, []);
        renderSeen();
        var pop = document.getElementById('mp-srch-pop'); if (pop) pop.classList.remove('is-short');
      }
    });

    clearBtn.addEventListener('click', function () {
      inputEl.value = '';
      clearBtn.classList.add('mp-hidden');
      setState('empty');
      inputEl.focus();
    });

    overlay.addEventListener('click', function (e) {
      var pill = e.target.closest('.mp-srch__pill');
      if (!pill) return;
      var q = pill.getAttribute('data-q');
      inputEl.value = q;
      clearBtn.classList.remove('mp-hidden');
      doSearch(q);
    });

    overlay.addEventListener('click', function (e) {
      if (!e.target.closest('.mp-srch-card')) return;
      document.body.style.overflow = '';
      var q = inputEl.value.trim();
      if (q.length >= MIN_QUERY) pushList(RECENT_KEY, q, RECENT_MAX);  // la ricerca che ha portato al profumo si ricorda
    });
  }

  /* Apertura richiamabile da fuori: serve al menu nuovo (prova) per aprire QUESTA ricerca,
     la stessa dell'intestazione, invece di un pannello suo. */
  window.MPSearch = { open: openSearch, close: closeSearch };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
